import { useNavigate } from '@tanstack/react-router';
import { Palette } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { lookName } from '@/lib/studioB/takeover';

export interface LookFields {
  lookRef?: string;
  lookLabel?: string;
  lookSource?: string;
}

const WHO_CHOSE: Record<string, string> = {
  person: 'You picked this look',
  words: 'Your words named this look',
  ivy: 'Ivy chose this look',
  switch: 'You switched to this look',
};

/** The look a video was made in, by name, and the way to make another in it. */
export function LookChip({ outline }: { outline: LookFields }) {
  const navigate = useNavigate();
  if (!outline.lookRef) return null;
  const label = outline.lookLabel || lookName(outline.lookRef);
  const who = outline.lookSource ? WHO_CHOSE[outline.lookSource] : undefined;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-look-chip
          className="flex h-7 max-w-[180px] flex-shrink-0 items-center gap-1.5 rounded-[var(--b-radius-control)] bg-b-raised px-2.5 text-b-control text-b-t1 transition-colors hover:bg-b-elevated"
        >
          <Palette className="h-3.5 w-3.5 flex-shrink-0" aria-hidden />
          <span className="truncate">{label}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-64 space-y-2 p-3 text-sm">
        <p className="font-medium">{label}</p>
        {who && <p className="text-xs text-muted-foreground">{who}</p>}
        <button
          type="button"
          className="text-left text-sm font-medium text-primary hover:underline"
          onClick={() => void navigate({ to: '/', search: { slide: undefined, look: outline.lookRef } })}
        >
          Another video in this look
        </button>
        <p className="text-xs text-muted-foreground">To change it, ask Ivy. The scenes get rebuilt.</p>
      </PopoverContent>
    </Popover>
  );
}
